<script lang="ts" setup>
import { ref, computed } from 'vue';
import { Drop } from '@/components/dragdrop';
import { DetailsBuilderContract } from '@/components/builder/details';
import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { BlueprintDefinition } from '@/components/builder/details/blueprints/BlueprintDefinition';

defineOptions({
    name: 'DynamicDetailsDesignRuller',
    components: {
        'drop': Drop
    }
});

const props = defineProps({
  "before": null,
  "details": null,
  "title": null
});
const emit = defineEmits(["insert", "add", "drop"]);

const dragover = ref(false);

const design = computed(() => props.details.designMode());

const dropComponent = (e: any): void =>
{
    if (e.definition)
        triggerAdd(e.definition, props.before);

    if (e.component)
        triggerDrop(e.component, props.before);

    dragover.value = false;
};

const insert = (e: any): void =>
{
    emit('insert', props.before);
};

const triggerAdd = (definition: BlueprintDefinition, before: Blueprint): void =>
{
    emit('add', definition, before);
};

const triggerDrop = (component: Blueprint, before: Blueprint): void =>
{
    emit('drop', component, before);
};
</script>

<template>
    <div class="ruller" v-if="design">
        <drop class="drop" @drop="dropComponent" @dragover="dragover = true" @dragleave="dragover = false">
            <div class="hover" :class="{'dragover': dragover}" :title="title" @click.stop.prevent="insert" @mouseover.stop>
                <div class="line">
                    <i class="far fa-plus-circle"></i>
                </div>
            </div>
        </drop>
    </div>
</template>

<style lang="scss" scoped>
.ruller {
    position: relative;
    width: 100%;

    .drop {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 5;
        margin-top: -6px;

        .hover {
            padding: 6px 0 6px 15px;
            cursor: pointer;

            .line {
                visibility: hidden;
                position: relative;
                background-color: var(--bs-primary);
                height: 2px;
                width: 100%;

                .far {
                    top: -7px;
                    left: -15px;
                    position: absolute;
                    font-size: 16px;
                    color: var(--bs-primary);
                }
            }

            &:hover,
            &.dragover {
                .line {
                    visibility: visible;
                }
            }
        }
    }
}
</style>
